/** An error above the submit button, announced to screen readers. */
export function FormError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p role="alert" className="rounded-md bg-negative-soft px-3 py-2 text-label text-negative">
      {message}
    </p>
  );
}
